import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import _ from "lodash";
import { Tooltip } from "@material-ui/core";
import { Box } from "@mui/system";
import { useGlobalListStyles } from "./globalStyles";

const NumberFieldInput = ({
  name,
  control,
  label = undefined,
  required = false,
  disabled = false,
  min = undefined,
  max = undefined,
  step = undefined,
  varchar = "20,10",
  size = undefined,
  tooltipMessage = undefined,
  tooltipIcon = undefined,
  removeZeroTrim = true,
  onCustomBlur = undefined,
  className = undefined,
  placeholder = undefined,
}) => {
const labelWithAsterisk = required ? `${label} *` : label;
const { setError, clearErrors } = useFormContext();
const classes = useGlobalListStyles();

// Parse varchar prop into limits
  let beforeLimit = null;
  let afterLimit = null;
  if (varchar) {
    const parts = varchar?.split(",");
    beforeLimit = parts[0]?.trim() ? parseInt(parts[0].trim(), 10) : null;
    afterLimit = parts[1]?.trim() ? parseInt(parts[1].trim(), 10) : null;
  }

  // on blur of the field
  function onhandleBlur(field) {
    const val = field.value;

    if (removeZeroTrim) {
      const num = parseFloat(val);
      if (!isNaN(num)) {
        field.onChange(num);
      }
    } else {
      field.onChange(val);
    }
    onCustomBlur?.(val);
  }

  // prevent on key down or up
  function onhandleKeyDown(e) {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  }

  // on change field
 function handleonChange(e, field) {
    let inputVal = e.target.value;

    // Allow only digits and one decimal point
    inputVal = inputVal.replace(/[^0-9.]/g, "");
    const parts = inputVal.split(".");

    // Limit before-decimal digits
    if (beforeLimit && parts[0].length > beforeLimit) {
      parts[0] = parts[0].slice(0, beforeLimit);
    }

    // If user typed multiple decimals, keep only the first
    if (parts.length > 2) {
      parts.splice(2);
    }

    // Limit after-decimal digits
    if (afterLimit && parts[1]?.length > afterLimit) {
      parts[1] = parts[1].slice(0, afterLimit);
    }

    // Join the parts back
    inputVal = parts.join(".");
    // more than max value should not allow
    if (max != null && !isNaN(inputVal) && inputVal > max) {
      setError(name, {
        type: "manual",
        message: `Value cannot be greater than ${max}`,
      });
      return;
    } else {
      clearErrors(name);
      field.onChange(inputVal);
    }

    field.onChange(inputVal);
  }

  // Construct the custom Label with Icon
  const renderLabel = () => {
    if (_.isEmpty(label)) return "";

    if (tooltipMessage && tooltipIcon) {
      return (
        <Box component="span" className={classes.dfac}>
          {labelWithAsterisk}
          <Tooltip title={tooltipMessage} placement="right">
            <span
              className={classes.fieldInfoTooltip}
              onMouseDown={(e) => e.stopPropagation()}
            >
              {tooltipIcon}
            </span>
          </Tooltip>
        </Box>
      );
    }
    return labelWithAsterisk;
  };

  return (
    <Controller
  name={name}
  control={control}
  defaultValue={""}
  render={({ field, fieldState: { error } }) => (
    <TextField
      {...field}
      fullWidth
      className={className}
      label={renderLabel()}
      type="text"
      disabled={disabled}
      size={size}
      error={!!error}
      helperText={error?.message}
      inputProps={{
        min,
        max,
        step,
        inputMode: "numeric",
        maxLength: beforeLimit + (afterLimit ? afterLimit + 1 : 0),
      }}
      value={field.value ?? ""}
      placeholder={placeholder}
      {...(placeholder ? { InputLabelProps: { shrink: true } } : {})}
      onChange={(e) => handleonChange(e, field)}
      onBlur={() => onhandleBlur(field)}
      onWheel={(e) => e.target.blur()}
      onKeyDown={(e) => onhandleKeyDown(e)}
    />
  )}
/>
  );
};

export default NumberFieldInput;